// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_bw-2";
export var aiChatCartContainerExit = "_bw-4";
export var aiChatContainerLarge = "_bw-0";
export var aiChatContainerSmall = "_bw-1";
export var aiChatIcon = "_bw-6";
export var slideInFromRight = "_bw-3";
export var slideOutToRight = "_bw-5";